/** @file Records a refusal for the Activity panel (a batch, undo/redo/revert, a server error); keeps 20. */
import { makeError } from '@pose2d/format/pose2dError';
import { toPose2DError } from '@pose2d/format/toPose2DError';
import type { CommandCall } from '@pose2d/format/types';
import { liveStore } from '../../stores/liveStore';

const KEEP = 20;
let nextId = 1;

/** `thrown` may be an Error carrying `.pose2d`, a bare Pose2DError or anything else (shown as INTERNAL). */
export function pushNotice(calls: CommandCall[] | null, thrown: unknown): void {
  const error = toPose2DError(thrown) ?? toPose2DError({ pose2d: thrown }) ?? makeError('INTERNAL');
  liveStore.setState((s) => ({ notices: [...s.notices, { id: nextId++, calls, error }].slice(-KEEP) }));
}
